import { select } from '@ps/web-core-store';
import type React from 'react';
import { useSelector } from 'react-redux';

import type { Tournament } from '../../types/MTT';

import CurrencyStatusIcon from './CurrencyStatusIcon';
import GameTypeStatusIcon from './GameTypeStatusIcon';
import SeatsStatusIcon from './SeatsStatusIcon';
import SpeedStatusIcon from './SpeedStatusIcon';

type Props = Tournament;

const TournamentStatusIcons: React.FC<Props> = (tournament) => {
  const siteDefaultTournamentCurrency = useSelector(
    select.currency.getSiteDefaultTournamentCurrency
  );
  const showCurrencyIcon = siteDefaultTournamentCurrency !== tournament.currency;

  return (
    <>
      {showCurrencyIcon && <CurrencyStatusIcon currency={tournament.currency} />}
      <GameTypeStatusIcon {...tournament} />
      <SpeedStatusIcon speed={tournament.tournSpeed} />
      <SeatsStatusIcon seats={tournament.seats} />
    </>
  );
};

export default TournamentStatusIcons;
